// Hungarian translations (Magyar)
export const hu = {
  // Navigation
  nav: {
    home: "Főoldal",
    rooms: "Szobák",
    amenities: "Szolgáltatások",
    gallery: "Galéria",
    virtualTour: "Virtuális Túra",
    location: "Helyszín",
    contact: "Kapcsolat",
    bookNow: "Foglalás"
  },
  
  // Hero
  hero: {
    tagline: "Családi 3 csillagos hotel, 2 percre a Velika Plaža strandtól, Ulcinj",
    description: "Egyszerű, családi vezetésű 3 csillagos hotel a Kepi i Gjeranave-n, kb. 2 perc sétára a homoktól a Velika Plaža, Ulcinj 12 km-es strandjának elején. Reggeli, vacsora, medence, Wi-Fi és garázs az árban. A szobák tiszták és praktikusak, nem luxus kivitelűek — a legtöbbnek erkélye van, sok a tengerre néz.",
    exploreRooms: "Szobák Felfedezése",
    viewGallery: "Galéria Megtekintése",
    veryGood: "Nagyon Jó",
    reviews: "vélemény",
    starHotel: "3 csillagos szálloda",
    bookDirect: "Foglaljon közvetlenül és spóroljon",
    bestPrice: "Olcsóbb, mint a Booking.com-on ugyanarra a szobára",
    freeCancellation: "Ingyenes lemondás a rugalmas áraknál",
    noBookingFees: "Nincsenek foglalási díjak",
    checkAvailability: "Élő elérhetőség →"
  },
  
  // Booking
  booking: {
    checkAvailability: "Elérhetőség Ellenőrzése és Foglalás",
    checkIn: "Bejelentkezés",
    checkOut: "Kijelentkezés",
    adults: "Felnőttek",
    children: "Gyerekek",
    adult: "Felnőtt",
    child: "Gyerek",
    searchAvailability: "Elérhetőség Keresése",
    secureBooking: "Biztonságos foglalás • Legjobb ár garancia • Ingyenes lemondás a legtöbb szobánál",
    freeCancellation: "Ingyenes lemondás a legtöbb foglalásnál"
  },
  
  // Rooms
  rooms: {
    title: "Egyszerű, tiszta szobák a strandnál",
    subtitle: "Szállás",
    description: "13 szobatípus a kompakt egyágyastól a kéthálószobás apartmanig. Mindegyikben légkondicionáló, saját fürdőszoba és ingyenes Wi-Fi; a legtöbb erkélyes. A bútorok praktikusak, nem designer darabok.",
    viewDetails: "Részletek",
    bookNow: "Foglalás",
    perNight: "/éjszaka",
    guests: "Vendég",
    backToRooms: "Vissza az Összes Szobához",
    roomAmenities: "Szoba Felszereltsége",
    standardFeatures: "Alapfelszerelés"
  },
  
  // Room Names (Hungarian)
  roomNames: {
    room1: "Kétágyas szoba tengerre néző erkéllyel",
    room2: "Kétágyas szoba a medence mellett",
    room3: "Gazdaságos kétágyas szoba erkéllyel (kilátás nélkül)",
    room4: "Kétágyas szoba tengerre néző közös terasszal",
    room5: "Executive háromágyas szoba tengerre néző erkéllyel",
    room6: "Kétágyas szoba pótággyal - tengerre néző erkéllyel",
    room7: "Kétszobás családi apartman",
    room8: "Családi szoba közös terasszal",
    room9: "Családi szoba terasszal",
    room10: "Kis egyágyas szoba",
    room11: "Háromágyas szoba erkéllyel",
    room12: "Családi szoba hegyekre néző kilátással",
    room13: "Egyszobás apartman"
  },
  
  // Amenities
  amenities: {
    title: "Szállodai Szolgáltatások",
    subtitle: "Amit Kínálunk",
    beachfront: "Tengerparti Elhelyezkedés",
    beachfrontDesc: "Közvetlen hozzáférés a Long Beach-hez",
    childrenPool: "Gyerekmedence",
    childrenPoolDesc: "Biztonságos medence családoknak",
    restaurant: "Étterem és Kávézó",
    restaurantDesc: "Balkáni konyha · alkoholmentes",
    wifi: "Ingyenes WiFi",
    wifiDesc: "Nagysebességű internet",
    parking: "Ingyenes Parkolás",
    parkingDesc: "Biztonságos parkolás",
    shuttle: "Reptéri Transzfer",
    shuttleDesc: "€80 a Podgorica és Tivat reptérről (kérésre)",
    frontDesk: "24 Órás Recepció",
    frontDeskDesc: "24/7 szolgáltatás",
    elevator: "Lift",
    elevatorDesc: "Minden emelet"
  },
  
  // Gallery
  gallery: {
    intro: "Fedezze fel a Hotel La Rosa Negra szépségét és Ulcinj varázsát.",
    title: "Fotógaléria",
    subtitle: "Fedezze Fel Szállodánkat",
    all: "Összes",
    rooms: "Szobák",
    pool: "Medence",
    beach: "Strand",
    restaurant: "Étterem",
    exterior: "Külső"
  },
  
  // Virtual Tour
  virtualTour: {
    title: "360° Virtuális Túra",
    subtitle: "Ismerje Meg Szállodánkat",
    description: "Tegyen egy virtuális sétát gyönyörű szállodánkban"
  },
  
  // Location
  location: {
    title: "Helyszínünk",
    subtitle: "Keressen Meg Minket",
    address: "Cím",
    nearbyAttractions: "Közeli Látnivalók"
  },
  
  // Contact
  contact: {
    title: "Kapcsolat",
    subtitle: "Lépjen Velünk Kapcsolatba",
    name: "Név",
    email: "Email",
    message: "Üzenet",
    send: "Üzenet Küldése",
    phone: "Telefon",
    whatsapp: "WhatsApp"
  },
  
  // FAQ
  faq: {
    intro: "Válaszok a Hotel La Rosa Negrával kapcsolatos gyakori kérdésekre.",
    title: "Gyakran Ismételt Kérdések",
    subtitle: "GYIK"
  },
  
  // Footer
  footer: {
    quickLinks: "Gyors Linkek",
    contactInfo: "Kapcsolati Információk",
    followUs: "Kövessen Minket",
    rights: "Minden jog fenntartva",
    starHotel: "csillagos szálloda",
    description: "Fedezze fel a mediterrán báj és a modern kényelem tökéletes ötvözetét közvetlenül a Velika Plažán (Hosszú strand), Ulcinj, Montenegró.",
    rooms: "Szobák és lakosztályok",
    amenities: "Szolgáltatások",
    gallery: "Galéria",
    location: "Helyszín",
    reviews: "Vélemények",
    legal: "Jogi",
    privacy: "Adatvédelmi szabályzat",
    terms: "Általános Szerződési Feltételek",
    cookies: "Süti szabályzat",
    cancellation: "Lemondási szabályzat"
  },

  // Smart language-hint toast
  langHint: {
    message: "Ez az oldal magyarul is elérhető",
    switch: "Váltás",
    dismiss: "Bezár"
  },
  
  // Why Book Direct
  whyBookDirect: {
    eyebrow: "Közvetlen foglalás",
    heading: "Miért foglaljon közvetlenül?",
    lead: "Itt olcsóbb, mint a Booking.com-on, és közvetlenül velünk intézi — pontosan ezt kapja",
    b1t: "Olcsóbb, mint a Booking.com",
    b1d: "Közvetlen árunk 10%-kal alacsonyabb a Booking.com-os árunknál ugyanarra a szobára és időpontra. Ott olcsóbbat talált? Küldje el a linket, kiegyenlítjük.",
    b2t: "10% kedvezmény",
    b2d: "A 10% már benne van az itt látható árban — kód és extra díjak nélkül.",
    b3t: "Érthető lemondási feltételek",
    b3d: "A rugalmas árak a foglalásnál megjelenő dátumig ingyen lemondhatók; a vissza nem téríthető árak fizetés előtt egyértelműen jelölve vannak.",
    b4t: "Ember válaszol",
    b4d: "WhatsApp, telefon vagy e-mail — a recepció általában néhány órán belül válaszol, 08:00–23:00 között.",
    cta: "Foglaljon közvetlenül és spóroljon"
  },

  // Amenities section headings/CTA
  amenitiesSection: {
    eyebrow: "Szolgáltatások",
    heading: "Ami a hotelben van",
    lead: "Csak az, ami valóban itt van — se több, se kevesebb.",
    ctaTitle: "Kérdése van foglalás előtt?",
    ctaLead: "Kérdezzen bármit a szobákról, a strandról vagy az ideérkezésről — őszintén válaszolunk.",
    ctaButton: "Konsziergé elérése"
  },

  // Contact section
  contactSection: {
    eyebrow: "Lépjen kapcsolatba",
    heading: "Vegye fel velünk a kapcsolatot",
    lead: "Kérdése van? Itt vagyunk, hogy segítsünk. Keressen minket bármikor.",
    addressLabel: "Cím",
    phoneLabel: "Telefon",
    emailLabel: "Email",
    receptionLabel: "Recepció nyitvatartása",
    reception247: "24/7 - Mindig itt vagyunk Önnek",
    whatsappBtn: "Chat WhatsApp-on",
    emailBtn: "Email küldése",
    bookDirectTitle: "Foglaljon közvetlenül és spóroljon",
    bookDirectDesc: "Kapjon 10% kedvezményt a weboldalunkon történő foglalás esetén",
    checkAvailability: "Elérhetőség ellenőrzése",
    whatsappPrefill: "Üdvözlöm, a La Rosa Negra Hotelről szeretnék érdeklődni"
  },

  // Reviews section
  reviews: {
    eyebrow: "Vendégértékelések",
    heading: "Amit a vendégek mondanak — változtatás nélkül",
    lead: "Az értékeléseket úgy vesszük át a Booking.com-ról, ahogy írták, a kritikus részekkel együtt. Ítélje meg Ön.",
    veryGood: "Nagyon jó",
    reviewsCount: "vélemény",
    starHotel: "3 csillagos szálloda",
    readMoreOn: "Olvasson több véleményt itt",
    translatedFrom: "Fordítás innen: {lang}",
    showOriginal: "Eredeti megjelenítése",
    showTranslation: "Fordítás megjelenítése"
  },

  // Handoff
  handoff: {
    prompt: "Inkább csapatunkkal beszélne?",
    button: "Folytatás WhatsApp-on",
    prefix: "Üdvözlöm, Hotel La Rosa Negra! A virtuális asszisztensével beszéltem, és szeretném folytatni egy személlyel."
  },

  // Common
  common: {
    learnMore: "Tudj Meg Többet",
    seeAll: "Összes Megtekintése",
    close: "Bezárás",
    loading: "Betöltés..."
  }
};
